import { useCallback, useEffect, useState } from 'react';

export const useZillowNavbarPresentationalState = () => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

    const toggleMobileNav = useCallback(() => {
        setIsMobileNavOpen(lastValue => !lastValue);
    }, []);

    useEffect(() => {
        const onWindowResize = () => {
            setIsMobileNavOpen(false);
        };
        window.addEventListener('resize', onWindowResize);
        return () => {
            window.removeEventListener('resize', onWindowResize);
        };
    }, []);

    return {
        isMobileNavOpen,
        toggleMobileNav,
    };
};
